import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CatalogListModule } from '@draeger-academy/presentation/lib/modules/catalog-list';
import { DaLinkModule } from '@draeger-academy/presentation/lib/modules/da-link';
import { FilteringModule } from '@draeger-academy/presentation/lib/modules/filtering';
import { MyCourseItemModule } from '@draeger-academy/presentation/lib/modules/my-course-item';
import { ShowMoreModule } from '@draeger-academy/presentation/lib/modules/show-more';
import { TeaserBoxContainerModule } from '@draeger-academy/presentation/lib/modules/teaser-boxes-container';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { AccountBookingDetailComponent } from './account-booking/account-booking-detail.component';
import { ChangePasswordFormComponent } from './change-password-form/change-password-form.component';
import { AccountCoursesListComponent } from './courses-list/account-courses-list.component';
import { ForgotPasswordFormComponent } from './forgot-password-form/forgot-password-form.component';
import { AccountLandingComponent } from './landing/account-landing.component';
import { ResetPasswordFormComponent } from './reset-password-form/reset-password-form.component';

@NgModule({
    declarations: [
        AccountLandingComponent,
        AccountBookingDetailComponent,
        AccountCoursesListComponent,
        ChangePasswordFormComponent,
        ForgotPasswordFormComponent,
        ResetPasswordFormComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        //please do not change the order of the next 3 imports,

        TranslateModule.forChild(),
        RouterModule.forChild([]),
        LocalizeRouterModule.forChild([]),
        DaLinkModule,
        ShowMoreModule,
        MyCourseItemModule,
        FilteringModule,
        CatalogListModule,
        TeaserBoxContainerModule
    ],
    exports: [
        AccountLandingComponent,
        AccountBookingDetailComponent,
        AccountCoursesListComponent,
        ChangePasswordFormComponent,
        ForgotPasswordFormComponent,
        ResetPasswordFormComponent
    ]
})
export class AccountComponentsModule {}
